import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export function FullSpin() {
  return <div className="full-spin"><Spin indicator={<LoadingOutlined style={{ fontSize: '30px' }} />} /></div>;
}